import { tasksSlice } from './slice';

const Reducer = tasksSlice.reducer;
const Actions = tasksSlice.actions;

export * from './state';
export * from './task';

export { Reducer, Actions };
